import { SHOW_SIDEBAR_MENU } from '../constants';

const DEFAULT_STATE = {
  visibleSideBarMenu: false,
};

const SidebarMenuReducer = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case SHOW_SIDEBAR_MENU:
      return {...state, visibleSideBarMenu: action.data };
    default:
      return state;
  }
};

export default SidebarMenuReducer;
